"use client"
import "./Tabs.css"

const Tabs = ({ tabs = [], activeTab, onChange, actions, className = "" }) => {
  return (
    <div className={`tabs-container ${className}`}>
      <div className="tabs-header">
        <div className="tabs-list">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => onChange(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        {actions && <div className="tabs-actions">{actions}</div>}
      </div>
    </div>
  )
}

export default Tabs

